import classes from "../maintainers.module.scss";

import { useCodesPaginate } from "@/hooks/maintainers/codes";
import { agricolaName, formatMiles, formatMilesDecimalNew } from "@/services/Utils";
import { useSelector } from "react-redux";
import CustomBadge from "@/components/desktop/badge/CustomBadge";

import { ReactComponent as RemoveSvg } from "@/assets/images/desktop/remove.svg";
import { ReactComponent as RefreshSvg } from "@/assets/images/desktop/refresh.svg";

const AptitudesTableBody = ({ base, handleDelete, restoreDelete, handleRefresh }) => {
	const { search, parameter } = useSelector((state) => state.auth.filter);

	const { data } = useCodesPaginate({
		...base,
		search,
		parameter: parameter || "code",
	});

	const { codes: list } = data ? data : {};
	const { data: codes } = list ? list : {};

	return (
		<tbody>
			{codes &&
				codes.map((item, i) => {
					item.total_content = item.total_content ? item.total_content.replaceAll(".", ",") : 0;

					return (
						<tr className={`${classes.table_tr}`} key={i}>
							<td className={`${classes.table_td} ${classes.first_td}`}>
								<div className={`${classes.table_div} ${classes.first_div} ${classes.center}`} style={{ fontWeight: "bold" }} title={item.id}>
									{item.code}
								</div>
							</td>
							<td className={`${classes.table_td}  `}>
								<div className={`${classes.table_div} ${classes.long_text}`}>{agricolaName(item.customer_name)}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.long_text}`} style={{ paddingLeft: "11px" }}>
									{item.product_name}
								</div>
							</td>

							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.center} `}>{formatMiles(item.quantity === 0 ? 1 : item.quantity)}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.center}`}>
									{item.total_content < 0
										? 0
										: `${item.total_content ? formatMilesDecimalNew(item.total_content) : 0} ${item.unit_measurement}`}
								</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.long_text} `}>{item.dealer_name}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.center} `}>{item.dealer_number}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.center} `}>{item.delivery_number}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.center} `}>
									{item.deleted ? (
										<CustomBadge variant="danger" className={classes.span_danger} onClick={() => restoreDelete(item)}>
											Eliminado
										</CustomBadge>
									) : (
										""
									)}
								</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.last_div}`}>
									<RefreshSvg className={classes.icon} onClick={() => handleRefresh(item)} />
									<RemoveSvg className={classes.icon} onClick={() => handleDelete(item)} />
								</div>
							</td>
						</tr>
					);
				})}
		</tbody>
	);
};

export default AptitudesTableBody;
